// components
import { DeleteAccount as DeleteAccountPage } from '@karehero/llama';

const DeleteAccount = () => {
  return <DeleteAccountPage />;
};

export default DeleteAccount;
